<template>
    <footer class="p-2 f-grey mt-2">
        <div class="container">
            <div class="row">
                <div class="col-12 col-md-6">
                    <ul class="list-inline">
                        <li class="list-inline-item"><a href="#">&copy; COPYRIGHT DARMASISWA</a></li>
                        <li class="list-inline-item"><a href="#">About</a></li>
                        <li class="list-inline-item"><a href="#">Terms and Condition</a></li>
                        <li class="list-inline-item"><a href="#">Privacy</a></li>
                    </ul>
                </div>
                <div class="col-12 col-md-6 text-right">
                    Powered by <a href="#" class="link">Somearch Nusantara</a>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    
}
</script>
<style scoped>
    a {
        color: inherit;
    }
</style>